import { DotsVerticalCircleOutlineIcon } from './DotsVerticalCircleOutlineIcon';

/**
 * author: Michael Richins
 * id E2CD4D50-D64C-47B9-AF3B-C464D65CD4EB
 * name dots-vertical-circle-outline
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/dots-vertical-circle-outline.svg
 * tags
 */
export const EllipsisVerticalCircleOutlineIcon = DotsVerticalCircleOutlineIcon;
export default EllipsisVerticalCircleOutlineIcon